<template>
    <HeaderPart />

    <SuccessPage />

  <FooterPart />
</template>

<script>
// @ is an alias to /src
import SuccessPage from '@/pages/SuccessPage.vue'
import HeaderPart from '@/components/HeaderPart.vue';
import FooterPart from '@/components/FooterPart.vue';

export default {
  name: 'SuccessView',
  components: {
    SuccessPage,
    HeaderPart,
    FooterPart
  }
}
</script>
